import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { setAccountTab, setPaymentTab } from "../../../store/slices/navigation.slice";

const ChangeSubModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToProfile = () => {
    navigate(ROUTES.PROFILE);
    dispatch(setAccountTab(1));
    dispatch(setPaymentTab(2));
    dispatch(setOpenModal(""));
  };

  return (
    <div className={styles.subscriptionModalWrapper}>
      <div className={styles.removeSubModalTextContent}>
        <div className={styles.removeSubModalTitle}>{t("changeSubT")}</div>
        <div className={styles.removeSubModalDescr}>{t("changeSubD")}</div>
      </div>
      <div className={styles.subscriptionModalButtonWrapper}>
        <Button title={t("changeSubB1")} submit={() => dispatch(setOpenModal(""))} className={styles.confirm} />

        <Button title={t("changeSubB2")} submit={goToProfile} className={styles.cancel} />
      </div>
    </div>
  );
};

export default ChangeSubModal;
